import Compressor from 'compressorjs'

export async function compressImg(
  file: File,
  longImg?: boolean
): Promise<Blob> {
  const option = longImg
    ? {
        maxHeight: 15000,
        maxWidth: 1000
      }
    : {
        maxHeight: 4096,
        maxWidth: 4096
      }
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      ...option,
      success: (com) => {
        resolve(com)
      },
      error(err) {
        console.error(err.message)
        reject(err)
      }
    })
  })
}

// function uploadFile(file, ufid) {
//   const reader = new FileReader()
//   reader.readAsArrayBuffer(file)
//   reader.onload = function (e) {
//     let fcont = new Uint8Array(e.target.result)
//     const fsize = fcont.byteLength
//     const dataptr = pngtiny._malloc(fsize)
//     const retdata = pngtiny._malloc(4)
//     pngtiny.HEAPU8.set(fcont, dataptr)
//     pngtiny._tiny(dataptr, fsize, retdata)
//     var rdata = new Int32Array(pngtiny.HEAPU8.buffer, retdata, 1)
//     let size = rdata[0]
//     let blob = null
//     if (size > 0) {
//       let pic = new Uint8Array(size)
//       var rdata = new Uint8Array(pngtiny.HEAPU8.buffer, dataptr, size)
//       pic.set(rdata)
//       blob = new Blob([pic.buffer], { type: 'image/png' })
//       pic = null
//     } else {
//       blob = new Blob([fcont.buffer], { type: 'image/png' })
//       size = fsize
//     }
//     fcont = null
//     const url = (URL || webkitURL).createObjectURL(blob)
//     imgList.push({ name: file.name, data: blob })
//     const dr = ((((fsize - size) * 100) / fsize) | 0) + '%'
//     pngtiny._free(dataptr)
//     pngtiny._free(retdata)
//   }
// }
